import { all, fork, takeLatest, takeLeading } from 'redux-saga/effects';
import { sliceName } from '../redux/jobsSlice';
import * as Sagas from './saga';

function* watchFetchActiveJob() {
    yield takeLatest(`${sliceName}/fetchActiveJob`, Sagas.fetchJobSaga);
}

function* watchUpdateActiveJob() {
    yield takeLatest(`${sliceName}/updateActiveJob`, Sagas.updateJobSaga);
}

function* watchUpdateJobStatus() {
    yield takeLatest(`${sliceName}/updateJobStatus`, Sagas.updateJobStatusSaga);
}

function* watchDeleteJob() {
    yield takeLatest(`${sliceName}/deleteJob`, Sagas.deleteJobSaga);
}

function* watchFetchJobsPageStatistics() {
    yield takeLatest(
        `${sliceName}/fetchJobsPageStatistics`,
        Sagas.fetchJobsPageStatisticsSaga
    );
}

function* watchFetchJobAttributeList() {
    yield takeLeading(
        `${sliceName}/fetchJobAttributeList`,
        Sagas.fetchJobAttributeListSaga
    );
}

function* watchFetchJobRequirementsOptions() {
    yield takeLatest(
        `${sliceName}/fetchJobRequirementsOptions`,
        Sagas.fetchJobRequirementsOptionsSaga
    );
}

function* watchFetchJobBenefitsOptions() {
    yield takeLeading(
        `${sliceName}/fetchJobBenefitsOptions`,
        Sagas.fetchJobBenefitsOptionsSaga
    );
}

function* watchCreateJob() {
    yield takeLeading(`${sliceName}/createJob`, Sagas.createJobSaga);
}

function* watchFetchCandidatesJobs() {
    yield takeLatest(
        `${sliceName}/fetchCandidatesJobs`,
        Sagas.fetchCandidatesJobsSaga
    );
}

function* watchFetchAssignedJobList() {
    yield takeLeading(
        `${sliceName}/fetchAssignedJobList`,
        Sagas.fetchAssignedJobListSaga
    );
}

function* watchFetchJobSteps() {
    yield takeLatest(`${sliceName}/fetchJobSteps`, Sagas.fetchJobStepsSaga);
}

function* watchFetchJobsList() {
    yield takeLeading(`${sliceName}/fetchJobsList`, Sagas.fetchJobsListSaga);
}

function* watchFetchPublicTrackableSources() {
    yield takeLeading(
        `${sliceName}/fetchPublicTrackableSources`,
        Sagas.fetchPublicTrackableSourcesSaga
    );
}

function* watchFetchTrackableSources() {
    yield takeLeading(
        `${sliceName}/fetchTrackableSources`,
        Sagas.fetchTrackableSourceSaga
    );
}

function* watchCreateTrackableSource() {
    yield takeLatest(
        `${sliceName}/createTrackableSource`,
        Sagas.createTrackableSourceSaga
    );
}

function* watchFetchJobRequirementsRecomendations() {
    yield takeLatest(
        `${sliceName}/fetchJobRequirementsRecommendations`,
        Sagas.fetchJobRequirementsRecommendationsSaga
    );
}

function* watchFetchPublishedJobsOptions() {
    yield takeLatest(
        `${sliceName}/fetchPublishedJobsOptions`,
        Sagas.fetchPublishedJobsOptionsSaga
    );
}

function* watchFetchJobOverviewAndResponsibilities() {
    yield takeLatest(
        `${sliceName}/fetchJobOverviewAndResponsibilities`,
        Sagas.fetchJobOverviewAndResponsibilitiesSaga
    );
}

function* watchFetchActiveJobCandidates() {
    yield takeLatest(
        `${sliceName}/fetchActiveJobCandidates`,
        Sagas.fetchActiveJobCandidatesSaga
    );
}

function* watchUpdateActiveJobCandidate() {
    yield takeLatest(
        `${sliceName}/updateActiveJobCandidate`,
        Sagas.updateActiveJobCandidateSaga
    );
}

function* watchApplyTagToJob() {
    yield takeLatest(`${sliceName}/applyTagToJob`, Sagas.applyTagToJobSaga);
}

function* watchDeleteTagFromJob() {
    yield takeLatest(
        `${sliceName}/deleteTagFromJob`,
        Sagas.deleteTagFromJobSaga
    );
}

export function* jobsSagas() {
    yield all([
        fork(watchFetchActiveJob),
        fork(watchUpdateActiveJob),
        fork(watchUpdateJobStatus),
        fork(watchDeleteJob),
        fork(watchFetchJobsPageStatistics),
        fork(watchFetchJobAttributeList),
        fork(watchFetchJobRequirementsOptions),
        fork(watchCreateJob),
        fork(watchFetchCandidatesJobs),
        fork(watchFetchJobBenefitsOptions),
        fork(watchFetchAssignedJobList),
        fork(watchFetchPublicTrackableSources),
        fork(watchFetchTrackableSources),
        fork(watchCreateTrackableSource),
        fork(watchFetchJobSteps),
        fork(watchFetchJobsList),
        fork(watchFetchJobRequirementsRecomendations),
        fork(watchFetchPublishedJobsOptions),
        fork(watchFetchJobOverviewAndResponsibilities),
        fork(watchFetchActiveJobCandidates),
        fork(watchUpdateActiveJobCandidate),
        fork(watchApplyTagToJob),
        fork(watchDeleteTagFromJob),
    ]);
}
